import { render, staticRenderFns } from "./EditMaxCamModal.vue?vue&type=template&id=be82cfba&scoped=true"
import script from "./EditMaxCamModal.vue?vue&type=script&lang=ts"
export * from "./EditMaxCamModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be82cfba",
  null
  
)

export default component.exports